import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EditFontSvg, EditImageSvg, CloseIconSvg } from '../ui/Svgs';
import { useIncrementalPrompting } from '../../services/incrementalPromptingService';
import { useFetchFonts } from '../../services/fontListService';
import { useDispatch, useSelector } from 'react-redux';
import { setIsVisualizePageVisible, updateGeneratedImagesFromPastCreation } from '../../redux/createImageSlice';
import { setPrompt } from '../../redux/promptSlice';

const EditPrompt = ({ onClose, openSelectFontModal, imageData, imageInputValue, setImageInputValue, fontInputValue, setFontInputValue }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const incrementalPrompting = useIncrementalPrompting()
    const { fetchFontsForEditFont } = useFetchFonts();

    const { pastCreationData } = useSelector((state) => state.pastCreation);
    const { generatedImages, isImageLoading, } = useSelector((state) => state.createImage);

    const modalCloseRef = useRef(null);

    const [showEditFont, setShowEditFont] = useState(false);

    const disableGenerateButton = (!imageInputValue.trim() && !fontInputValue.trim()) || isImageLoading;

    const handleImageInputChange = (e) => {
        setImageInputValue(e.target.value);
    };

    const handleFontInputChange = (e) => {
        setFontInputValue(e.target.value);
    };

    const handleGenerate = () => {
        // const itPrompt = "<IT>" + imageInputValue 
        const itPrompt = imageInputValue 
        let replaceFontList = true
        if (!fontInputValue.trim()) {
            if (location.pathname === '/your-past-creations') {
                dispatch(setIsVisualizePageVisible(false));
                navigate('/generate-image');

                const matchingPastCreation = pastCreationData.find((item) => item.promptId === imageData.promptId);
                const matchingGeneratedImage = generatedImages[0].promptId === imageData.promptId;

                if (!matchingGeneratedImage) {
                    fetchFontsForEditFont(imageData.prompt, replaceFontList);
                    dispatch(setPrompt(imageData.prompt));
                    dispatch(updateGeneratedImagesFromPastCreation({
                        images: matchingPastCreation.images,
                    }))
                }
            }
            incrementalPrompting(itPrompt, imageData)
        } else {
            fetchFontsForEditFont(fontInputValue)
        }
        onClose()
        openSelectFontModal()
    }

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalCloseRef.current && !modalCloseRef.current.contains(e.target)) {
                onClose();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [])

    return (
        <div ref={modalCloseRef} className='relative h-[418px] w-[542px] m-10 bg-white rounded-[16px] border'>
            <CloseIconSvg onClick={onClose} className="absolute top-4 right-4 cursor-pointer" />
            <div className='h-full flex flex-col'>
                <div className='w-full h-[96px] border-b flex items-center'>
                    <h1 className='px-[40px] text-[28px] font-helveticaText-Medium font-[500] leading-[32px] text-cus_primary'>
                        Edit image with <span className='text-pink-primary font-helveticaText-Medium font-[500]'>AI</span>
                    </h1>
                </div>
                <div className='h-[72px] w-full px-[40px] flex items-center gap-[16px]'>
                    <button
                        onClick={() => setShowEditFont(false)}
                        className={`h-[40px] px-[16px] py-[8px] rounded-[8px] flexCenter gap-[8px] ${!showEditFont ? 'bg-pink-primary text-white' : 'text-cus_primary bg-gray-light'}`}
                    >
                        <EditImageSvg fill={!showEditFont ? 'white' : '#1E242C'} />
                        <span>Edit image</span>
                    </button>
                    <button
                        onClick={() => setShowEditFont(true)}
                        className={`h-[40px] px-[16px] py-[8px] rounded-[8px] flexCenter gap-[8px] ${showEditFont ? 'bg-pink-primary text-white' : 'text-cus_primary bg-gray-light'}`}
                    >
                        <EditFontSvg fill={showEditFont ? 'white' : '#1E242C'} />
                        <span>Edit font</span>
                    </button>
                </div>
                <div className='h-[136px] w-full px-[40px] border-b flex flex-col gap-[16px]'>
                    <p className='text-[13px] leading-[16px] text-cus_primary'>
                        Examples: {!showEditFont ? '"change font color to red" or "add a blue background"' : '"swap fonts" or "change font to Kairo Sans Bold”'}
                    </p>
                    <textarea
                        type="text"
                        placeholder={!showEditFont ? 'Type what you would like to change' : 'Change font to Kaisei Decol Regular'}
                        className='h-[80px] w-full p-[16px] text-[13px] border rounded-[8px] outline-none resize-none placeholder:text-[#667488] caret-pink-primary'
                        value={showEditFont ? fontInputValue : imageInputValue}
                        onChange={showEditFont ? handleFontInputChange : handleImageInputChange}
                    />
                </div>
                <div className='h-[112px] flex items-center px-[40px]'>
                    <button
                        onClick={handleGenerate}
                        disabled={disableGenerateButton}
                        className={`h-[48px] px-[16px] py-[8px] bg-pink-primary text-white rounded-[8px] flexCenter gap-[8px] ${disableGenerateButton ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                    >
                        Generate
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditPrompt;